export const CoordinateSystem = {
  DISPLAY: 0,
  WORLD: 1,
};

export default {
  CoordinateSystem,
};
